/**
 * Builds the full URL to open a video editor project, including auth query params.
 * Used by links and by programmatic navigation after creating a project.
 */
export function buildVideoEditorProjectUrl(options: {
  baseUrl: string;
  projectId: string;
  jwt: string;
  authAsUserId?: string;
}): string {
  const url = new URL(options.baseUrl);
  url.searchParams.set('projectId', options.projectId);
  url.searchParams.set('jwt', options.jwt);
  if (options.authAsUserId) {
    url.searchParams.set('auth_as', options.authAsUserId);
  }
  return url.toString();
}
